export default function pickObjectUtil (object, keys = []) {
  const pickedObject = {}
  keys.forEach(key => {
    if (key in object) {
      pickedObject[key] = object[key]
    }
  })
  return pickedObject
}
